// extracted by mini-css-extract-plugin
export var landingCtaVideoFormBox = "styles-module--landing-cta-video-form-box--omsqG";
export var landingCtaVideoFormContainer = "styles-module--landing-cta-video-form-container--15qKX";
export var landingCtaVideoFormFormContainer = "styles-module--landing-cta-video-form-form-container--oNccC";
export var landingCtaVideoFormLogo = "styles-module--landing-cta-video-form-logo---iKZW";
export var landingCtaVideoFormLogoContainer = "styles-module--landing-cta-video-form-logo-container--3059J";
export var landingCtaVideoFormWrapper = "styles-module--landing-cta-video-form-wrapper--r342w";
export var primary = "#06004d";
export var secondary = "#4dafd7";